// default initial state
import { LoginState } from '../../../../common/interface';

export const authInitialState: LoginState = {
  access_token: '',
  isLoggedIn: false,
  userProfile: null,
  isUserLoading: true,
  isRedirecting: false,
  expires_on: 0,
  loginEnv: 'prod',
};
